module.exports = "https://trybtryb-legacy.web.app/img/rounded-mobile.846ed88c.svg";